import {
  workflowPartnerOneUpgradeCuRouting
} from "./workflow-partner-one-upgrade-cu/workflow-partner-one-upgrade-cu.routing";
import {
  workflowPartnerOneUpgradeSlaRouting
} from "./workflow-partner-one-upgrade-sla/workflow-partner-one-upgrade-sla.routing";
import {
  workflowPartnerOneDowngradeCuRouting
} from "./workflow-partner-one-downgrade-cu/workflow-partner-one-downgrade-cu.routing";
import {
  workflowPartnerOneDowngradeSlaRouting
} from "./workflow-partner-one-downgrade-sla/workflow-partner-one-downgrade-sla.routing";
import {
  workflowPartnerOneTrialCreateRouting
} from "./workflow-partner-one-trial-create/workflow-partner-one-trial-create.routing";
import {
  workflowPartnerAddTrialPhonenumberRouting
} from "./workflow-partner-add-trial-phonenumber/workflow-partner-add-trial-phonenumber.routing";
import { WorkflowPartnerOneAvailabilityOrderCancelRouting } from "./workflow-partner-one-availability-order-cancel/workflow-partner-one-availability-order-cancel.routing";
import { workflowPartnerOneAvailabilityRouting } from "./workflow-partner-one-availability/workflow-partner-one-availability.routing";
import { WorkflowPartnerOneTariffRouting } from "./workflow-partner-one-tariff/workflow-partner-one-tariff.routing";
import { WorkflowPartnerOneTariffOrderCancelRouting } from "./workflow-partner-one-tariff-order-cancel/workflow-partner-one-tariff-order-cancel.routing";
import { workflowPartnerOneCancelPhonenumberRouting } from "./workflow-partner-one-cancel-phonenumber/workflow-partner-one-cancel-phonenumber.routing";
import { workflowPartnerAiTariffRouting } from "./workflow-partner-ai-tariff/workflow-partner-ai-tariff.routing";
import { WorkflowPartnerAiTariffOrderCancelRouting } from "./workflow-partner-ai-tariff-order-cancel/workflow-partner-ai-tariff-order-cancel.routing";

export const workflowPartnerRouting = [
  ...workflowPartnerOneUpgradeCuRouting,
  ...workflowPartnerOneUpgradeSlaRouting,
  ...workflowPartnerOneDowngradeCuRouting,
  ...workflowPartnerOneDowngradeSlaRouting,
  ...workflowPartnerOneTrialCreateRouting,
  ...workflowPartnerAddTrialPhonenumberRouting,
  ...WorkflowPartnerOneAvailabilityOrderCancelRouting,
  ...workflowPartnerOneAvailabilityRouting,
  ...WorkflowPartnerOneTariffRouting,
  ...WorkflowPartnerOneTariffOrderCancelRouting,
  ...workflowPartnerOneCancelPhonenumberRouting,
  ...workflowPartnerAiTariffRouting,
  ...WorkflowPartnerAiTariffOrderCancelRouting
]